import { InputType, relativeTimeOptions } from '../types';

export const RelativeTimeFormatInput: InputType = [
	{ value: 1, type: 'number' },
	{ value: 'day', type: 'options', options: relativeTimeOptions }
];
